import {StyledContainer, StyledButton} from "./StyledComponents";
import MediaItem from "./media-item/MediaItem";
import {KmsTypeRelatedMediaEntry} from "./types";
import {Typography} from "@kaltura/ds-react-components";
import {translate} from "@mediaspace/shared/utils";
import {useState} from "react";
import {useButtonAnalytics} from "@mediaspace/hooks";

export interface RelatedMediaProps {
    title?: string;
    relatedMedias?: KmsTypeRelatedMediaEntry[];
    analytics?: {
        action: string,
        buttonType: number
    }
}

/**
 * related media component
 */
export const RelatedMedia = (props: RelatedMediaProps) => {

    const {title = translate("Related Media"), relatedMedias = [], analytics} = props;

    const [mediasToShowCount, setMediasToShowCount] = useState<number>(10);
    const mediasToShow = relatedMedias.slice(0, mediasToShowCount);

    const sendButtonAnalytics = useButtonAnalytics();

    const handleShowMore = (e: React.MouseEvent<HTMLElement>) => {
        e.preventDefault();
        setMediasToShowCount(previous => previous + 20);
        if (!analytics) {
            return;
        }
        // send analytics
        sendButtonAnalytics(analytics.action, analytics.buttonType);
    }

    return (
        <StyledContainer className="kms-ds-media-page-sidebar-related-media">
            {mediasToShow.length > 0 && (
                <Typography variant={"h5"} className="kms-ds-media-page-sidebar-related-media-title">
                    {title}
                </Typography>
            )}

            {mediasToShow.map(media => (
               <MediaItem key={media.id} {...media} />
            ))}

            {mediasToShow.length < relatedMedias.length && (
                <StyledButton
                    variant={"borderless"}
                    onClick={handleShowMore}
                    component={"a"}
                    href={"kaltura.com"}
                >
                    {translate("Show more")}
                </StyledButton>
            )}
        </StyledContainer>
    );
};

export default RelatedMedia;
